<script setup lang="ts">
import { ref } from 'vue'
import { Settings } from 'lucide-vue-next'
import SettingsDropdown from '@/components/SettingsDropdown.vue'
import { useConfig } from '@/composables/useConfig'

defineProps<{
  username: string
  isSettingsOpen: boolean
}>()

const emit = defineEmits<{
  'toggle-settings': []
  'close-settings': []
  'logout': []
  'open-change-password': []
  'change-lang': [lang: string]
}>()

// 获取配置
const { config } = useConfig()

// Logo 图片加载状态
const logoError = ref(false)

const onLogoError = () => {
  console.warn('Horizontal logo load failed, fallback to text logo')
  logoError.value = true
}

const onLogoLoad = () => {
  logoError.value = false
}
</script>

<template>
  <header class="flex-none bg-white z-[60] sticky top-0">
    <div class="flex items-center justify-between px-4 py-3 border-b border-gray-50">
      <!-- Logo 区域 -->
      <div class="flex items-center">
        <!-- 显示横版 Logo 图片 -->
        <img
          v-if="config.horizontalLogoUrl && !logoError"
          :src="config.horizontalLogoUrl"
          :alt="config.title || 'Logo'"
          class="h-6 w-auto object-contain"
          style="transform: scale(2); transform-origin: left center;"
          @error="onLogoError"
          @load="onLogoLoad"
        />
        <!-- 降级到文字 Logo -->
        <div v-else class="px-3 py-0.5 font-bold text-xs tracking-tighter">
          {{ config.title }}
        </div>
      </div>

      <div class="text-gray-400 text-xs">{{ username }}</div>
      <div class="relative">
        <Settings class="text-gray-300 cursor-pointer" :size="18" @click="emit('toggle-settings')" />
        <SettingsDropdown
          v-if="isSettingsOpen"
          @change-lang="emit('change-lang', $event)"
          @close="emit('close-settings')"
          @logout="emit('logout')"
          @open-change-password="emit('open-change-password')"
        />
      </div>
    </div>
  </header>
</template>
